import { render, staticRenderFns } from "./clientes.vue?vue&type=template&id=38624336"
import script from "./clientes.vue?vue&type=script&lang=js"
export * from "./clientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports